/* global closest:false */
/* global trigger:false */

var FOCUSABLE_DIALOG_ELEMENTS = [
	'a[href]',
	'area[href]',
	'input:not([disabled])',
	'select:not([disabled])',
	'textarea:not([disabled])',
	'button:not([disabled])',
	'[tabindex="0"]',
];



function addOpenDialogListeners(dialog, elements) {
	// this approach will check also dynimacally added elements
	document.addEventListener('click', function(event) {
		if (event.target && closest(event.target, elements)) {
			event.preventDefault();
			event.stopPropagation();
			dialog.open();
		}
	});
};

function addCloseDialogListeners(dialog, elements) {
	// this approach will check also dynimacally added elements
	document.addEventListener('click', function(event) {
		if (dialog.isActive && event.target && closest(event.target, elements)) {
			event.preventDefault();
			event.stopPropagation();
			dialog.close();
		}
	});
};



function Dialog(dialogElement, options = {}) {
	this.dialogClassName = 'dialog';
	this.dialogElement = dialogElement;
	this.fragmentId = options.fragmentId || undefined; // when set we will change assign this dialog pane to specific fragment in URL
	this.overlayClassName = 'dialog-bg';
	this.overlayElement = document.querySelector('.' + this.overlayClassName);
	this.isActive = false;
	this.focusedElementBeforeOpen;
	this.scrollPosition;
	this.disabledEscClose = options.disableEscClose || false;
	this.connectedUrl = options.urlRewrite || undefined;

	this._openingTimeout;
	this._openStateTimeout;

	this.eventHandler = this._handleEvent.bind(this);

	var focusableElements = this.dialogElement.querySelectorAll(FOCUSABLE_DIALOG_ELEMENTS.join(', '));
	this.focusableElements = Array.prototype.slice.call(focusableElements);

	this.firstFocusableElement = this.focusableElements[0];
	this.initialFocusableElement = this.firstFocusableElement;
	this.lastFocusableElement = this.focusableElements[this.focusableElements.length - 1];

	// close modal by clicking on inner element with data-close attribute
	addCloseDialogListeners(this, '[data-close]');

	this.close(true); // Reset

	if (this.fragmentId || this.connectedUrl) {
		if (this.fragmentId && window.location.hash === ('#' + this.fragmentId)) {
			this.open();
		}

		if (this.connectedUrl && window.location.pathname === this.connectedUrl) {
			this.open();
		}

		window.addEventListener('popstate', this._handleState.bind(this));
	}
}



Dialog.prototype.open = function() {
	if (this.fragmentId) {
		var hash = '#' + this.fragmentId;
		if (window.history.pushState) {
			window.history.pushState(null, null, window.location.pathname + hash);
		} else {
			window.location.hash = hash;
		}
	}

	if (this.connectedUrl && window.location.pathname !== this.connectedUrl) {
		if (window.history.pushState) {
			window.history.pushState(null, null, this.connectedUrl);
		} else {
			window.location.pathname = this.connectedUrl;
		}
	}

	this.focusedElementBeforeOpen = document.activeElement;
	this.scrollPosition = document.documentElement.scrollTop;

	var htmlElement = document.getElementsByTagName('html')[0];
	htmlElement.classList.add('is-dialog-open');
	var contentEl = htmlElement.querySelector('.js-content');
	if (contentEl) {
		contentEl.setAttribute('aria-hidden', 'true');
	}
	var dialogsCount = htmlElement.getAttribute('data-active-dialogs-count');
	dialogsCount = dialogsCount ? parseInt(dialogsCount) : 0;
	var isSomeModalOpenBefore = dialogsCount == 0;
	dialogsCount = dialogsCount + 1;
	htmlElement.setAttribute('data-active-dialogs-count', dialogsCount);

	this.isActive = true;
	if (this.overlayElement && isSomeModalOpenBefore) {
		this.overlayElement.classList.add(this.overlayClassName + '--before-opening');
	}
	this.dialogElement.classList.add(this.dialogClassName + '--before-opening');
	this.dialogElement.removeAttribute('aria-hidden');
	this.dialogElement.removeAttribute('inert');

	this._openingTimeout = setTimeout(() => {
		if (this.overlayElement && isSomeModalOpenBefore) {
			this.overlayElement.classList.add(this.overlayClassName + '--opening');
		}
		this.dialogElement.classList.add(this.dialogClassName + '--opening');
	}, 50);

	this._openStateTimeout = setTimeout(() => {
		if (this.overlayElement && isSomeModalOpenBefore) {
			this.overlayElement.classList.remove(this.overlayClassName + '--before-opening');
			this.overlayElement.classList.remove(this.overlayClassName + '--opening');
			this.overlayElement.removeAttribute('aria-hidden');
			this.overlayElement.removeAttribute('inert');
		}
		this.dialogElement.classList.remove(this.dialogClassName + '--before-opening');
		this.dialogElement.classList.remove(this.dialogClassName + '--opening');
		this.initialFocusableElement.focus();
	}, 500);

	document.addEventListener('keydown', this.eventHandler);

	trigger(document, 'dialogopen', this);
};



Dialog.prototype.close = function(withoutAnimation) {
	const animatedClosing = withoutAnimation ? false : true;

	// Overlay layer is shared for all dialogs
	// We should check first presence of another open dialog before
	// we will decide to hide overlay layer.
	var htmlElement = document.getElementsByTagName('html')[0];
	var dialogsCount = htmlElement.getAttribute('data-active-dialogs-count');
	dialogsCount = dialogsCount ? parseInt(dialogsCount) : 0;

	// some resets for unwanted situations
	clearTimeout(this._openingTimeout);
	clearTimeout(this._openStateTimeout);
	if (this.overlayElement && dialogsCount <= 1) {
		this.overlayElement.classList.remove(this.overlayClassName + '--before-opening');
	}
	this.dialogElement.classList.remove(this.dialogClassName + '--before-opening');

	// this function can be used also as reset (called on already closed dialog)
	if (this.isActive) {
		// we are closing one dialog, so we should decrement dialogsCount
		dialogsCount = dialogsCount > 1 ? (dialogsCount - 1) : 0;
		htmlElement.setAttribute('data-active-dialogs-count', dialogsCount);

		if (dialogsCount == 0) {
			htmlElement.classList.remove('is-dialog-open');
			const contentEl = htmlElement.querySelector('.js-content');
			if (contentEl) {
				contentEl.removeAttribute('aria-hidden');
			}
		}
	}

	if (this.fragmentId && this.isActive) {
		if (window.history.replaceState) {
			window.history.replaceState('', document.title, window.location.pathname);
		} else {
			window.location.hash = '';
		}
	}

	if (this.isActive && animatedClosing) {
		if (this.overlayElement && dialogsCount == 0) {
			this.overlayElement.classList.add(this.overlayClassName + '--before-closing');
		}
		this.dialogElement.classList.add(this.dialogClassName + '--before-closing');

		setTimeout(() => {
			if (this.overlayElement && dialogsCount == 0) {
				this.overlayElement.classList.add(this.overlayClassName + '--closing');
			}
			this.dialogElement.classList.add(this.dialogClassName + '--closing');
		}, 50);

		setTimeout(() => {
			this.isActive = false;
			if (this.overlayElement && dialogsCount == 0) {
				this.overlayElement.classList.remove(this.overlayClassName + '--before-closing');
				this.overlayElement.classList.remove(this.overlayClassName + '--closing');
				this.overlayElement.setAttribute('aria-hidden', true);
				this.overlayElement.setAttribute('inert', 'inert');
			}
			this.dialogElement.classList.remove(this.dialogClassName + '--before-closing');
			this.dialogElement.classList.remove(this.dialogClassName + '--closing');
			this.dialogElement.setAttribute('aria-hidden', true);
			this.dialogElement.setAttribute('inert', 'inert');

			if (this.focusedElementBeforeOpen && dialogsCount == 0) {
				this.focusedElementBeforeOpen.focus();
				window.scrollTo(0, this.scrollPosition);
			}
		}, 500);
	} else {
		if (this.overlayElement && dialogsCount == 0) {
			this.overlayElement.setAttribute('aria-hidden', true);
			this.overlayElement.setAttribute('inert', 'inert');
		}
		this.dialogElement.setAttribute('aria-hidden', true);
		this.dialogElement.setAttribute('inert', 'inert');

		if (this.isActive && this.focusedElementBeforeOpen) {
			this.focusedElementBeforeOpen.focus();
			window.scrollTo(0, this.scrollPosition);
		}

		this.isActive = false;
	}

	document.removeEventListener('keydown', this.eventHandler);

	trigger(document, 'dialogclose', this);
};



Dialog.prototype._handleState = function() {
	if (!this.isActive && (
		(this.fragmentId && window.location.hash === ('#' + this.fragmentId)) ||
		(this.connectedUrl && window.location.pathname === this.connectedUrl)
	)) {
		this.open();
	} else {
		if (this.isActive) {
			this.close();
		}
	}

	trigger(document, 'dialogpopstate', this);
};



Dialog.prototype._handleKeyDown = function(e) {
	var KEY_TAB = 9;
	var KEY_ESC = 27;

	if (!this.isActive) {
		return false;
	}

	const handleBackwardTab = () => {
		if (document.activeElement === this.firstFocusableElement) {
			e.preventDefault();
			this.lastFocusableElement.focus();
		}
	}

	const handleForwardTab = () => {
		if (document.activeElement === this.lastFocusableElement) {
			e.preventDefault();
			this.firstFocusableElement.focus();
		}
	}

	switch (e.keyCode) {
		case KEY_TAB:
			if (this.focusableElements.length === 1) {
				e.preventDefault();
				break;
			}

			if (e.shiftKey) {
				handleBackwardTab();
			} else {
				handleForwardTab();
			}

			break;

		case KEY_ESC:
			if (!this.disabledEscClose) {
				this.close();
			}
			break;

		default:
			break;

	}
};



Dialog.prototype._handleEvent = function(event) {
	switch(event.type) {
		case 'keydown':
			this._handleKeyDown(event);
			break;
	}
};



Dialog.prototype.addEventListeners = function(openDialogSel, closeDialogSel) {
	addOpenDialogListeners(this, openDialogSel);

	if (closeDialogSel) {
		addCloseDialogListeners(this, closeDialogSel);
	}
};
